// Firebase configuration for different environments
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

// Production Firebase configuration
const productionConfig: FirebaseConfig = {
  apiKey: "AIzaSyABZFHqG8o0oExSUja4JfBPs4Mg33Jy7SM",
  authDomain: "bbtech-b67fa.firebaseapp.com",
  projectId: "bbtech-b67fa",
  storageBucket: "bbtech-b67fa.firebasestorage.app",
  messagingSenderId: "1053963008505",
  appId: "1:1053963008505:web:b6633cdd83d8e8f563e528",
  measurementId: "G-TBYPMNRMLF"
};

// Development Firebase configuration
const developmentConfig: FirebaseConfig = {
  apiKey: "AIzaSyDicnb3F3UtPp55McoQfnwoN0oxcB1JxTY",
  authDomain: "bbtech-dev.firebaseapp.com",
  projectId: "bbtech-dev",
  storageBucket: "bbtech-dev.firebasestorage.app",
  messagingSenderId: "119574184120",
  appId: "1:119574184120:web:a7723dcece89cf46c1344d"
};

// Get current environment
const getEnvironment = (): 'development' | 'production' => {
  // Check if we're in development mode
  if (import.meta.env.DEV) {
    return 'development';
  }
  
  // Check for environment variable override
  if (import.meta.env.VITE_FIREBASE_ENV === 'development') {
    return 'development';
  }
  
  // Default to production
  return 'production';
};

// Get Firebase config based on environment
export const getFirebaseConfig = (): FirebaseConfig => {
  const env = getEnvironment();
  
  switch (env) {
    case 'development':
      return developmentConfig;
    case 'production':
    default:
      return productionConfig;
  }
};

// Export current config
export const firebaseConfig = getFirebaseConfig();
